<template>
  <div class="home" :class="mounted">
    <section class="hero">
      <img src="../assets/lk-white-transparent.png" class="hero-image" :class="mounted">
    </section>
    <div class="container">
      <section>
        <h1 class="introhead">welcome to lexi's kitchen</h1>
        <p>
          This is the web app companion to the Lexi's Kitchen Alexa skill. You can find the skill on in your Alexa app or on the <a href="https://t.co/qR4FauxUIh?amp=1">Amazon web site</a>.
        </p>
        <div class="buttonContainer">
          <Button href="https://t.co/qR4FauxUIh?amp=1" label="Lexi's Kitchen Alexa Skill"></Button>
        </div>
      </section>
      <section>

      </section>

    </div>
  </div>
</template>

<script>
import Button from '../components/Button';

export default {
  name: 'home',
  components: {
    Button: Button
  },
  data() {
    return {
      mounted: 'loading'
    }
  },
  beforeMount() {
    this.$store.commit('setHeaderClass', '')
  },
  mounted() {
    setTimeout(() => {
      this.mounted = 'loaded'
    }, 500)

  },
  beforeDestroy() {
    this.mounted = 'loading'
  }
}
</script>

<style scoped lang="scss">
  .container {
    max-width: 760px;
    margin: auto;
  }

  a {
    text-decoration: none;
    color: #666666;
    font-weight: 700;
    &:hover {
      color: var(--amazonOrange);
    }
  }

  .hero {
    width: 100vw;
    margin-left: -20px;
    background-color: #a72c2c;
    text-align: center;

    img {
      margin: 6vh auto;
      max-height: 30vh;
      max-width: 80%;
      transition: all 1s ease;
      &.loading {
        opacity: 0;
        transform: scale(0.8);
      }
      &.loaded {
        opacity: 1;
        transform: scale(1);
      }
    }
  }

  .introhead {
    text-align: right;
    font-size: 40px;
  }

  .buttonContainer {
    display: grid;
    justify-content: center;
  }
  @media (max-width: 767px) {
    .introhead {
      font-size: 28px;
    }
  }

</style>
